import budget from './budget.json'
import action from './action.json'
import client from './client.json'
import segment from './segment.json'
import actionCategory from './action-category.json'
import actionSubcategory from './action-subcategory.json'
import campaign from './campaign.json'
import media from './media.json'
import product from './product.json'
import brand from './brand.json'
import provider from './provider.json'

import menu from './menu.json'

import english from './english.json'

const exportedObject = {
  budget,
  action,
  client,
  segment,
  actionCategory,
  actionSubcategory,
  campaign,
  media,
  product,
  brand,
  provider,
  menu,
  ...english
}

export default exportedObject;